import { render, staticRenderFns } from "./TaskTemplateViewForm.vue?vue&type=template&id=10686452"
import script from "./TaskTemplateViewForm.vue?vue&type=script&lang=js"
export * from "./TaskTemplateViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports